import React, { Component, Fragment } from "react";
import "./OtpLoginFormCard.scss";
import Logo from "../Logo/index";
import Tabs from "../Tabs/index";
import { ReactComponent as PasswordVisible } from "./icons/passwordvisible.svg";
import { ReactComponent as PasswordNotVisible } from "./icons/passwordNotVisible.svg";
import Button from "./Button";
import Rectangle from "./Rectangle";
import "./Rectangle.scss";
import { ToastContainer, toast } from "react-toastify";

class OtpLoginFormCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailMobileFocused: false,
    };
  }
  render() {
    const {
      companyTypeTabButton,
      companyType,
      selectCompanyType,
      toggleOtpLogin,
      onClickSendOtp,
      handleEmailOrMobileChange,
      emailOrMobileInput,
      shouldRenderCompanyTab
    } = this.props;
    return (
      <Fragment>
        {/* <Rectangle className={"otpRectangleTopL"} /> */}
        {/* <Rectangle className={"otpRectangleTopS"} /> */}
        <div className="otpLoginFormCardMain">
          <ToastContainer />
          <div className="otpLoginFormCard">
            <div className="otpLoginFormLogo">
              <Logo className="otpLoginLogoImage" />
            </div>
            {shouldRenderCompanyTab() && <div className="companyTypeButton">
              <Tabs
                tabs={companyTypeTabButton}
                activeTabId={companyType}
                selectTab={selectCompanyType}
              />
            </div>}
            <div className="otpLoginFormEmailMain">
              <p className="otpLoginFormEmailLable">Email or Mobile Number</p>
              <div className={`otpLoginFormEmailBox ${this.state.isEmailMobileFocused ? 'box-focused' : ''}`}>
                <input
                  type="text"
                  className="otpLoginFormEmailInput"
                  value={emailOrMobileInput}
                  onChange={handleEmailOrMobileChange}
                  onFocus={() => this.setState({ isEmailMobileFocused: true })}
                  onBlur={() => this.setState({ isEmailMobileFocused: false })}
                >
                </input>
              </div>
            </div>

            <div className="otpLoginButtonBox">
              <Button
                Name={"Send OTP"}
                className={"otpLoginButton"}
                onClick={onClickSendOtp}
              />
            </div>
            <div className="backToSignInLableBox">
              <p className="backToSignInLable" onClick={toggleOtpLogin}>
                Back To SignIn
              </p>
            </div>
          </div>
        </div>
        {/* <Rectangle className={"otpRectangleBottomL"} /> */}
        {/* <Rectangle className={"otpRectangleBottomS"} /> */}
      </Fragment>
    );
  }
}
export default OtpLoginFormCard;
